import apiClient from './client';
import {
  AnomalyDetectionResponse,
  InsightListResponse,
  InsightResponse,
  InsightSummary,
  RecommendationsResponse,
} from '@/types/data';

export const insightsApi = {
  // インサイト一覧取得
  getInsights: async (params: {
    company_id: number;
    insight_type?: string;
    severity?: string;
    status?: string;
    page?: number;
    per_page?: number;
  }): Promise<InsightListResponse> => {
    const response = await apiClient.get('/api/insights', { params });
    return response.data;
  },

  // インサイト詳細取得
  getInsight: async (insightId: number): Promise<InsightResponse> => {
    const response = await apiClient.get(`/api/insights/${insightId}`);
    return response.data;
  },

  // インサイトサマリー取得
  getSummary: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<InsightSummary> => {
    const response = await apiClient.get('/api/insights/summary', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // 異常検知実行
  detectAnomalies: async (params: {
    company_id: number;
    metric?: string;
    baseline_days?: number;
    analysis_days?: number;
    z_score_threshold?: number;
    save_insights?: boolean;
  }): Promise<AnomalyDetectionResponse> => {
    const response = await apiClient.get('/api/insights/anomalies', {
      params: {
        company_id: params.company_id,
        metric: params.metric ?? 'daily_value',
        baseline_days: params.baseline_days ?? 30,
        analysis_days: params.analysis_days ?? 7,
        z_score_threshold: params.z_score_threshold ?? 2.0,
        save_insights: params.save_insights ?? false,
      },
    });
    return response.data;
  },

  // 改善提案取得
  getRecommendations: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<RecommendationsResponse> => {
    const response = await apiClient.get('/api/insights/recommendations', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // ステータス更新
  updateStatus: async (
    insightId: number,
    update: { status: string; resolution_notes?: string }
  ): Promise<{ id: number; status: string; message: string }> => {
    const response = await apiClient.patch(`/api/insights/${insightId}/status`, update);
    return response.data;
  },

  // インサイト生成
  generateInsights: async (
    companyId: number
  ): Promise<{
    company_id: number;
    anomalies_detected: number;
    insights_generated: number;
    message: string;
  }> => {
    const response = await apiClient.post('/api/insights/generate', null, {
      params: { company_id: companyId },
    });
    return response.data;
  },
};
